export default "__VITE_ASSET__DdHoeXnD__"